import { render, staticRenderFns } from "./mo-formfield-decorator.html?vue&type=template&id=e4f69796&scoped=true&external"
import script from "./mo-formfield-decorator.ts?vue&type=script&lang=ts&external"
export * from "./mo-formfield-decorator.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-formfield-decorator.scss?vue&type=style&index=0&id=e4f69796&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f69796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4f69796')) {
      api.createRecord('e4f69796', component.options)
    } else {
      api.reload('e4f69796', component.options)
    }
    module.hot.accept("./mo-formfield-decorator.html?vue&type=template&id=e4f69796&scoped=true&external", function () {
      api.rerender('e4f69796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-formfield-decorator/mo-formfield-decorator.vue"
export default component.exports